<template>
  <div class="shipping-quotes">
    <template v-if="stillValid">
      <quoted-shipments
        :split-shipment-article-link="splitShipmentArticleLink"
        :shipments="shipments"
      />
    </template>
    <div
      v-else-if="overseasDestination && unshippableByAirVariants.length > 0"
      class="alert alert-warning"
    >
      <p>
        Due to flashpoint restrictions, these product(s) cannot be shipped to
        you:
      </p>
      <ul class="unshippable-variants">
        <li v-for="(variant, index) in unshippableByAirVariants" :key="index">
          {{ variant.name }}
        </li>
      </ul>
    </div>
    <div v-else class="alert alert-danger">
      <span>
        We had trouble quoting your order. Please try again.
      </span>
    </div>
  </div>
</template>

<script>
  import QuotedShipments from "./quoted-shipments"

  export default {
    components: {
      QuotedShipments,
    },
    props: {
      splitShipmentArticleLink: {
        type: String,
        required: true,
      },
      stillValid: {
        type: Boolean,
        required: true,
      },
      overseasDestination: {
        type: Boolean,
        required: true,
      },
      shipments: {
        type: Array,
        required: true,
      },
    },
    computed: {
      unshippableByAirVariants() {
        const unshippableVariants = []
        this.shipments.forEach((shipment) => {
          unshippableVariants.push(...shipment.unshippable_by_air_variants)
        })
        return unshippableVariants
      },
    },
  }
</script>
